// Libs
import { Box, Typography } from '@mui/material';
import classNames from 'classnames/bind';
import { useEffect, useCallback, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

// Components, Layouts, Pages
import { Loading } from '~/components/common';

// Others
import { connectGoogleGmail } from '~/thunks/google/googleThunk';
import { MESSAGE_GOOGLE_CONNECTED } from '~/utils/constants/common';
import { IQueryGetTokenGoogle } from '~/utils/interface/google';
import { useAppDispatch } from '~/utils/redux/hooks';

// Styles, images, icons
import styles from './GoogleCallBack.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const GoogleCallBack = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const params = useMemo(() => Object.fromEntries([...searchParams]), [searchParams]);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [isLoading, setIsLoading] = useState<boolean>(false);
  //#endregion Declare State

  //#region Implement Hook
  const handleConnectGoogle = useCallback((body: IQueryGetTokenGoogle) => {
    setIsLoading(true);
    dispatch(connectGoogleGmail(body))
      .unwrap()
      .then((res) => {
        window.opener.postMessage(MESSAGE_GOOGLE_CONNECTED, '*');
        window.close();
      })
      .catch((error) => {})
      .finally(() => {
        window.opener.postMessage(MESSAGE_GOOGLE_CONNECTED, '*');
        window.close();
        setIsLoading(false);
      });
  }, [dispatch]);

  useEffect(() => {
    const payload: IQueryGetTokenGoogle = {
      code: params?.code,
      state: params?.state,
    };

    handleConnectGoogle(payload);
  }, [params, handleConnectGoogle]);
  //#endregion Implement Hook

  //#region Handle Function

  return (
    <Box component={'div'} className={cx('container')}>
      <Typography component='p' variant='body1'>
        {isLoading && <Loading />}
      </Typography>
    </Box>
  );
};

export default GoogleCallBack;
